const splitWith = (separator: string | RegExp, divider: string) => (
  value: string
) => value.split(separator).join(divider);

export default splitWith;
